// import React, { useState, useEffect, useMemo, useContext } from "react";
// import { Row, Col, Figure, Image } from "react-bootstrap";
// import axios from "axios";
// import Footer from "../work/footer";
// import WorksDetailsHeader from "./work_details_header";
// import { UserContext } from "../../use_context";
// import { Link, useParams } from "react-router-dom";
// import ScrolltoTop from "../button/scrolltotop";
// import { useInView } from "react-intersection-observer";
// import "bootstrap/dist/css/bootstrap.min.css";

// const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

// function WorkDetailsMain() {
//   const { workData, setWorkData } = useContext(UserContext);
//   const [loading, setLoading] = useState(true);
//   const [mediaData, setMediaData] = useState([]);
//   const [images, setImages] = useState({});
//   const [categories, setCategories] = useState([]);
//   const [teamMembers, setTeamMembers] = useState([]);
//   const { workId } = useParams();

//   // ✅ Memoize selectedWork
//   const selectedWork = useMemo(
//     () => workData?.find((w) => w.id === Number(workId)),
//     [workData, workId]
//   );

//   // ✅ Safe media fetching
//   const videoId = selectedWork?.acf?.location_video;
//   const videoMedia = mediaData.find((m) => m?.id === videoId);

//   const rightSideImgId = selectedWork?.acf?.right_side_img;
//   const rightSideImgData = mediaData.find((m) => m?.id === rightSideImgId);

//   const gifImgId = selectedWork?.acf?.location_gif;
//   const gifImgData = mediaData.find((m) => m?.id === gifImgId); // ✅ Fix here

//   // ✅ InView hooks
//   const { ref: heroRef, inView: heroVisible } = useInView({
//     triggerOnce: true,
//   });
//   const { ref: imageBlockRef, inView: imageVisible } = useInView({
//     triggerOnce: true,
//   });
//   const { ref: videoRef, inView: videoVisible } = useInView({
//     triggerOnce: true,
//   });

//   // ✅ Selected categories
//   const selectedCategories = selectedWork?.["work-category"] || [];

//   const selectedCategoryNames = useMemo(() => {
//     return categories
//       .filter((cat) => selectedCategories.includes(cat.id))
//       .map((cat) => cat.name);
//   }, [categories, selectedCategories]);

//   // ✅ Related works
//   const relatedWorks = workData
//     .filter(
//       (w) =>
//         w.id !== selectedWork?.id &&
//         w["work-category"]?.some((catId) => selectedCategories.includes(catId))
//     )
//     .slice(0, 3);

//   // ✅ Load featured images for all works
//   useEffect(() => {
//     if (!workData?.length) return;

//     const fetchImages = async () => {
//       const imgMap = {};
//       await Promise.all(
//         workData.map(async (w) => {
//           if (!w.featured_media) return;
//           try {
//             const res = await axios.get(
//               `${API_BASE_URL}/media/${w.featured_media}`
//             );
//             imgMap[w.id] = res.data.source_url;
//           } catch (e) {
//             console.warn(`Failed to load image for work ${w.id}`, e);
//           }
//         })
//       );
//       setImages(imgMap);
//     };

//     fetchImages();
//   }, [workData]);

//   // ✅ Fetch all workData
//   useEffect(() => {
//     const fetchWorkData = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/work/`);
//         setWorkData(response.data);
//       } catch (error) {
//         console.error("Failed to fetch work data", error);
//       }
//     };

//     if (!workData || workData.length === 0) {
//       fetchWorkData();
//     }
//   }, [setWorkData]);

//   // ✅ Fetch media related to selectedWork
//   useEffect(() => {
//     const fetchMediaData = async () => {
//       if (!selectedWork) return;

//       const allMediaData = [];
//       const fetchedMediaIds = new Set();

//       const mediaIds = [
//         selectedWork?.featured_media,
//         selectedWork?.acf?.location_video,
//         selectedWork?.acf?.right_side_img,
//         selectedWork?.acf?.location_gif,
//         ...(selectedWork?.acf?.location_images || []).map((img) => img.image),
//       ].filter(Boolean);

//       for (const id of mediaIds) {
//         if (!fetchedMediaIds.has(id)) {
//           try {
//             const response = await axios.get(`${API_BASE_URL}/media/${id}`);
//             allMediaData.push(response.data);
//             fetchedMediaIds.add(id);
//           } catch (error) {
//             console.error(`Error fetching media ID ${id}:`, error);
//           }
//         }
//       }

//       setMediaData(allMediaData);
//       setLoading(false); // ✅ Only after media is fetched
//     };

//     fetchMediaData();
//   }, [selectedWork]);

//   // ✅ Fetch category list
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}/work-category`);
//         setCategories(res.data);
//       } catch (error) {
//         console.error("Failed to fetch categories", error);
//       }
//     };

//     fetchCategories();
//   }, []);

//   // ✅ Fetch team list for selected work
//   useEffect(() => {
//     const fetchTeam = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}/work/${workId}`);
//         const members = res.data?.acf?.team_list || [];
//         setTeamMembers(members);
//       } catch (err) {
//         console.error("Failed to fetch team_list", err);
//       }
//     };

//     fetchTeam();
//   }, [workId]);

//   // ✅ Reset loading state when workId changes
//   useEffect(() => {
//     setLoading(true);
//   }, [workId]);

//   // ✅ Loader fallback
//   if (loading || !selectedWork) {
//     return (
//       <div className="loader-mask">
//         <div className="loader"></div>
//       </div>
//     );
//   }

//   return (
//     <React.Fragment>
//       <WorksDetailsHeader />
//       <ScrolltoTop />
//       <main>
//         <section
//           ref={heroRef}
//           className="work-detail hero page-hero page-cover hero-fixed hero-overlay-top hero-overlay-bottom lottie-wrapper"
//           style={{
//             backgroundImage: heroVisible
//               ? `url('${
//                   mediaData.find((m) => m.id === selectedWork.featured_media)
//                     ?.guid?.rendered || ""
//                 }')`
//               : "none",
//           }}
//         >
//           <div className="text-container">
//             <span className="title-text">{selectedWork.title.rendered}</span>
//             <br />
//             <span className="location-text">{selectedWork.acf.location}</span>
//           </div>
//         </section>

//         <section className="page-content medium-container" id="project-details">
//           <div className="project-meta">
//             <Row className="align-items-stretch gx-5">
//               <Col md={4}>
//                 <div className="d-flex flex-column">
//                   <dl className="project-location mb-3">
//                     <dt>{selectedWork.acf.location_title}</dt>
//                     <dd>{selectedWork.acf.location}</dd>
//                   </dl>
//                   <dl className="project-year mb-3">
//                     <dt>{selectedWork.acf.completion_year_title}</dt>
//                     <dd>{selectedWork.acf.completion_year}</dd>
//                   </dl>
//                   <dl className="project-component mb-3">
//                     <dt>{selectedWork.acf.project_component_title}</dt>
//                     <dd>{selectedWork.acf.project_component}</dd>
//                   </dl>

//                   {teamMembers.length > 0 && (
//                     <div className="team-section mt-4">
//                       <h3 className="mb-4">{selectedWork.acf?.team_title}</h3>
//                       <Row>
//                         {teamMembers.map((member, index) => (
//                           <Col key={index} md={6} className="text-center mb-4">
//                             <h5>{member.name}</h5>
//                             <p>{member.designation}</p>
//                           </Col>
//                         ))}
//                       </Row>
//                     </div>
//                   )}

//                   <div className="project-description mt-5">
//                     {selectedWork.acf.location_desc?.map((item, index) => (
//                       <p key={index} className="desc-para font-semibold mb-3">
//                         {item.description}
//                       </p>
//                     ))}
//                   </div>
//                 </div>
//               </Col>

//               <Col md={8} className="d-flex flex-column">
//                 <div ref={imageBlockRef} className="flex-grow-1">
//                   {imageVisible && rightSideImgData && (
//                     <img
//                       src={rightSideImgData.source_url}
//                       alt={rightSideImgData.alt_text}
//                       loading="lazy"
//                       className="img-fluid w-100"
//                       style={{ objectFit: "cover", height: "100%" }}
//                     />
//                   )}
//                 </div>
//               </Col>
//             </Row>
//           </div>
//           <Row>
//             <Col>
//               <div
//                 ref={imageBlockRef}
//                 className="d-flex justify-content-center align-items-center"
//               >
//                 {imageVisible && gifImgData && (
//                   <img
//                     src={gifImgData.source_url}
//                     alt={gifImgData.alt_text}
//                     loading="lazy"
//                     className="img-fluid"
//                     style={{
//                       width: "500px",
//                       height: "600px",
//                       objectFit: "cover",
//                     }}
//                   />
//                 )}
//               </div>
//             </Col>
//           </Row>

//           <div className="project-description">
//             {videoVisible && videoMedia && (
//               <div ref={videoRef} className="project-media video-viewport">
//                 <video width="1190" height="1190" controls>
//                   <source src={videoMedia.source_url} type="video/mp4" />
//                   Your browser does not support the video tag.
//                 </video>
//               </div>
//             )}

//             <div>
//               {selectedWork.acf?.location_images?.map((imgObj, index) => {
//                 const imageData = mediaData.find((m) => m.id === imgObj.image);
//                 return (
//                   imageData?.source_url && (
//                     <img
//                       key={index}
//                       className={`aligncenter wp-image-${imgObj.image} size-full mb-3`}
//                       src={imageData.source_url}
//                       alt=""
//                       width="1500"
//                       height="1136"
//                       loading="lazy"
//                     />
//                   )
//                 );
//               })}
//             </div>
//           </div>
//         </section>

//         <section
//           className="project-featured medium-container"
//           style={{ direction: "rtl" }}
//         >
//           <h2 className="section-title font-regular text-center">
//             Explore other{" "}
//             <strong>
//               {selectedCategoryNames.length > 0
//                 ? selectedCategoryNames.join(", ")
//                 : "featured"}{" "}
//               projects
//             </strong>
//           </h2>

//           <div className="work-listing grid-col">
//             {relatedWorks.map((workItem) => {
//               const imageUrl = images[workItem.id];

//               return (
//                 <Col className="worklisting-image" key={workItem.id}>
//                   <Link to={`/worksdetails/${workItem.id}`}>
//                     <div className="work-listing-item mix featured card media-card workplaces">
//                       <Figure>
//                         {imageUrl && (
//                           <Image
//                             src={imageUrl}
//                             alt={`Work item ${workItem.id}`}
//                             className="img2"
//                             loading="lazy"
//                           />
//                         )}
//                         <Figure.Caption>
//                           <span className="title">
//                             {workItem.title.rendered}
//                           </span>
//                           <span className="location">
//                             {workItem.acf?.location}
//                           </span>
//                         </Figure.Caption>
//                       </Figure>
//                     </div>
//                   </Link>
//                 </Col>
//               );
//             })}
//           </div>
//         </section>
//       </main>
//       <Footer />
//     </React.Fragment>
//   );
// }

// export default WorkDetailsMain;
import React, { useState, useEffect, useMemo, useContext } from "react";
import { Row, Col, Figure, Image } from "react-bootstrap";
import axios from "axios";
import Footer from "../work/footer";
import WorksDetailsHeader from "./work_details_header";
import { UserContext } from "../../use_context";
import { Link, useParams } from "react-router-dom";
import ScrolltoTop from "../button/scrolltotop";
import { useInView } from "react-intersection-observer";
import "bootstrap/dist/css/bootstrap.min.css";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

function WorkDetailsMain() {
  const { workData, setWorkData } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [mediaData, setMediaData] = useState([]);
  const [images, setImages] = useState({});
  const [categories, setCategories] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const { workId } = useParams();

  const selectedWork = useMemo(
    () => workData?.find((w) => w.id === Number(workId)),
    [workData, workId]
  );

  const videoId = selectedWork?.acf?.location_video;
  const videoMedia = mediaData.find((m) => m?.id === videoId);

  const rightSideImgId = selectedWork?.acf?.right_side_img;
  const rightSideImgData = mediaData.find((m) => m?.id === rightSideImgId);

  const gifImgId = selectedWork?.acf?.location_gif;
  const gifImgData = mediaData.find((m) => m?.id === gifImgId);

  const { ref: heroRef, inView: heroVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: imageBlockRef, inView: imageVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: videoRef, inView: videoVisible } = useInView({
    triggerOnce: true,
  });

  const selectedCategories = selectedWork?.["work-category"] || [];

  const selectedCategoryNames = useMemo(() => {
    return categories
      .filter((cat) => selectedCategories.includes(cat.id))
      .map((cat) => cat.name);
  }, [categories, selectedCategories]);

  useEffect(() => {
    if (!workData?.length) return;

    const fetchImages = async () => {
      const promises = workData.map(async (w) => {
        if (!w.featured_media) return null;
        try {
          const res = await axios.get(
            `${API_BASE_URL}/media/${w.featured_media}`
          );
          return { id: w.id, url: res.data.source_url };
        } catch (e) {
          console.warn(`Failed to load image for work ${w.id}`, e);
          return null;
        }
      });

      const results = await Promise.all(promises);
      const imgMap = {};
      results.forEach((result) => {
        if (result) {
          imgMap[result.id] = result.url;
        }
      });

      setImages(imgMap);
    };

    fetchImages();
  }, [workData]);

  useEffect(() => {
    const fetchWorkData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/work?per_page=100`);

        setWorkData(response.data);
      } catch (error) {
        console.error("Failed to fetch work data", error);
      }
    };

    const fetchWorkById = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/work/${workId}`);
        setWorkData((prev) => [...prev, response.data]);
      } catch (error) {
        console.error("Failed to fetch work by ID", error);
      }
    };

    if (!workData || workData.length === 0) {
      fetchWorkData();
    } else if (!selectedWork) {
      fetchWorkById();
    }
  }, [workData, selectedWork, workId, setWorkData]);

  const relatedWorks = useMemo(() => {
    if (!workData || !selectedWork || !selectedCategories?.length) return [];

    return workData
      .filter(
        (w) =>
          w.id !== selectedWork.id &&
          w["work-category"]?.some((catId) =>
            selectedCategories.includes(catId)
          )
      )
      .slice(0, 3);
  }, [workData, selectedWork, selectedCategories]);

  // Fetch media for selected work
  useEffect(() => {
    const fetchMediaData = async () => {
      if (!selectedWork) return;

      const allMediaData = [];
      const fetchedMediaIds = new Set();

      const mediaIds = [
        selectedWork.featured_media,
        selectedWork?.acf?.location_video,
        selectedWork?.acf?.right_side_img,
        selectedWork?.acf?.location_gif,
        ...(selectedWork?.acf?.location_images || []).map((img) => img.image),
      ].filter(Boolean);

      for (const id of mediaIds) {
        if (!fetchedMediaIds.has(id)) {
          try {
            const response = await axios.get(`${API_BASE_URL}/media/${id}`);
            allMediaData.push(response.data);
            fetchedMediaIds.add(id);
          } catch (error) {
            console.error(`Error fetching media ID ${id}:`, error);
          }
        }
      }

      setMediaData(allMediaData);
      setLoading(false);
    };

    if (selectedWork) fetchMediaData();
  }, [selectedWork]);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/work-category`);
        setCategories(res.data);
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    };

    fetchCategories();
  }, []);

  // Fetch team for selected work
  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/work/${workId}`);
        const members = res.data?.acf?.team_list || [];
        setTeamMembers(members);
      } catch (err) {
        console.error("Failed to fetch team_list", err);
      }
    };

    fetchTeam();
  }, [workId]);

  // Reset loading on workId change
  useEffect(() => {
    setLoading(true);
  }, [workId]);

  if (loading || !selectedWork) {
    return (
      <div className="loader-mask">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <WorksDetailsHeader />
      <ScrolltoTop />
      <main>
        <section
          ref={heroRef}
          className="work-detail hero page-hero page-cover hero-fixed hero-overlay-top hero-overlay-bottom lottie-wrapper"
          style={{
            backgroundImage: heroVisible
              ? `url('${
                  mediaData.find((m) => m.id === selectedWork.featured_media)
                    ?.guid?.rendered || ""
                }')`
              : "none",
          }}
        >
          <div className="text-container">
            <span className="title-text">{selectedWork.title.rendered}</span>
            <br />
            <span className="location-text">{selectedWork.acf.location}</span>
          </div>
        </section>

        <section className="page-content medium-container" id="project-details">
          <div className="project-meta">
            <Row className="align-items-stretch gx-5">
              <Col md={4}>
                <div className="d-flex flex-column">
                  <dl className="project-location mb-3">
                    <dt>{selectedWork.acf.location_title}</dt>
                    <dd>{selectedWork.acf.location}</dd>
                  </dl>
                  <dl className="project-year mb-3">
                    <dt>{selectedWork.acf.completion_year_title}</dt>
                    <dd>{selectedWork.acf.completion_year}</dd>
                  </dl>
                  <dl className="project-component mb-3">
                    <dt>{selectedWork.acf.project_component_title}</dt>
                    <dd>{selectedWork.acf.project_component}</dd>
                  </dl>

                  {teamMembers.length > 0 && (
                    <div className="team-section mt-4">
                      <h3 className="mb-4">{selectedWork.acf?.team_title}</h3>
                      <Row>
                        {teamMembers.map((member, index) => (
                          <Col key={index} md={6} className="text-center mb-4">
                            <h5>{member.name}</h5>
                            <p>{member.designation}</p>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}

                  <div className="project-description mt-5">
                    {selectedWork.acf.location_desc?.map((item, index) => (
                      <p key={index} className="desc-para font-semibold mb-3">
                        {item.description}
                      </p>
                    ))}
                  </div>
                </div>
              </Col>

              <Col md={8} className="d-flex flex-column">
                <div ref={imageBlockRef} className="flex-grow-1">
                  {imageVisible && rightSideImgData && (
                    <img
                      src={rightSideImgData.source_url}
                      alt={rightSideImgData.alt_text}
                      loading="lazy"
                      className="img-fluid w-100"
                      style={{ objectFit: "cover", height: "100%" }}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </div>

          <Row>
            <Col>
              <div
                ref={imageBlockRef}
                className="d-flex justify-content-center align-items-center"
              >
                {imageVisible && gifImgData && (
                  <img
                    src={gifImgData.source_url}
                    alt={gifImgData.alt_text}
                    loading="lazy"
                    className="img-fluid"
                    style={{
                      width: "500px",
                      height: "600px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            </Col>
          </Row>

          <div className="project-description">
            {videoVisible && videoMedia && (
              <div ref={videoRef} className="project-media video-viewport">
                <video width="1190" height="1190" controls>
                  <source src={videoMedia.source_url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            )}

            <div>
              {selectedWork.acf?.location_images?.map((imgObj, index) => {
                const imageData = mediaData.find((m) => m.id === imgObj.image);
                return (
                  imageData?.source_url && (
                    <img
                      key={index}
                      className={`aligncenter wp-image-${imgObj.image} size-full mb-3`}
                      src={imageData.source_url}
                      alt=""
                      width="1500"
                      height="1136"
                      loading="lazy"
                    />
                  )
                );
              })}
            </div>
          </div>
        </section>

        <section
          className="project-featured medium-container"
          style={{ direction: "rtl" }}
        >
          <h2 className="section-title font-regular text-center">
            Explore other{" "}
            <strong>
              {selectedCategoryNames.length > 0
                ? selectedCategoryNames.join(", ")
                : "featured"}{" "}
              projects
            </strong>
          </h2>

          <div className="work-listing grid-col">
            {relatedWorks.map((workItem) => {
              const imageUrl = images[workItem.id];
              return (
                <Col className="worklisting-image" key={workItem.id}>
                  <Link to={`/worksdetails/${workItem.id}`}>
                    <div className="work-listing-item mix featured card media-card workplaces">
                      <Figure>
                        {imageUrl && (
                          <Image
                            src={imageUrl}
                            alt={`Work item ${workItem.id}`}
                            className="img2"
                            loading="lazy"
                          />
                        )}
                        <Figure.Caption>
                          <span className="title">
                            {workItem.title.rendered}
                          </span>
                          <span className="location">
                            {workItem.acf?.location}
                          </span>
                        </Figure.Caption>
                      </Figure>
                    </div>
                  </Link>
                </Col>
              );
            })}
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  );
}

export default WorkDetailsMain;
